(() => {
  if (window.GEM_PRODUCT_SECTIONS_INITIALIZED) return;
  window.GEM_PRODUCT_SECTIONS_INITIALIZED = true;

  const SELECTORS = {
    section: '[data-gem-product-section]',
    offerCard: '[data-offer-card]',
    buyOptionCard: '[data-buy-option-card]',
    finalOptionCard: '[data-final-option-card]',
    addToCartBtn: '[data-ajax-add-to-cart]',
    ctaPrice: '[data-cta-price]',
    ctaText: '[data-cta-text]',
    galleryThumb: '[data-gallery-thumb]',
    heroMainImage: '[data-hero-main-image]'
  };

  function formatMoney(cents, moneyFormat) {
    const amount = (Number(cents || 0) / 100).toFixed(2);

    if (!moneyFormat) {
      return `₹${amount.replace(/\.00$/, '')}`;
    }

    if (moneyFormat.includes('{{amount_no_decimals}}')) {
      return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)));
    }

    if (moneyFormat.includes('{{amount}}')) {
      return moneyFormat.replace('{{amount}}', amount);
    }

    return `₹${amount.replace(/\.00$/, '')}`;
  }

  function getSectionState(section) {
    return {
      productId: section.dataset.productId,
      defaultVariantId: section.dataset.defaultVariantId,
      moneyFormat: section.dataset.moneyFormat || '₹{{amount}}'
    };
  }

  function getActiveOffer(section) {
    return section.querySelector(`${SELECTORS.offerCard}.is-active`) || section.querySelector(SELECTORS.offerCard);
  }

  function setActiveOffer(section, offerCard) {
    const cards = section.querySelectorAll(SELECTORS.offerCard);

    cards.forEach((card) => {
      const isActive = card === offerCard;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    updateCtaFromOffer(section, offerCard);
  }

  function updateCtaFromOffer(section, offerCard) {
    if (!offerCard) return;

    const ctaPrice = section.querySelector(SELECTORS.ctaPrice);
    const ctaText = section.querySelector(SELECTORS.ctaText);
    const addToCartBtn = section.querySelector(SELECTORS.addToCartBtn);
    const state = getSectionState(section);

    const price = offerCard.dataset.price;
    const buttonLabel = offerCard.dataset.buttonLabel || addToCartBtn?.dataset.defaultLabel || 'Add to Cart';
    const buttonPricePrefix = offerCard.dataset.buttonPricePrefix || '';

    if (ctaText) {
      ctaText.textContent = buttonLabel;
    }

    if (ctaPrice) {
      ctaPrice.textContent = `${buttonPricePrefix}${formatMoney(price, state.moneyFormat)}`;
    }

    if (addToCartBtn) {
      addToCartBtn.dataset.variantId = offerCard.dataset.variantId;
    }
  }

  async function addToCart(variantId, quantity = 1) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity
      })
    });

    if (!response.ok) {
      let errorMessage = 'Unable to add to cart';
      try {
        const errorData = await response.json();
        errorMessage = errorData?.description || errorData?.message || errorMessage;
      } catch (e) {}
      throw new Error(errorMessage);
    }

    return response.json();
  }

  async function refreshCartSections() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {}

    try {
      const res = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      const cart = await res.json();
      if (typeof window.globalcartcountupdate === 'function') {
        try { window.globalcartcountupdate(); } catch (_) {}
      }
      document.dispatchEvent(
        new CustomEvent('gem:cart-updated', {
          detail: { cart }
        })
      );
    } catch (e) {}
  }

  async function handleAddToCart(section, button) {
    const variantId = button.dataset.variantId || getActiveOffer(section)?.dataset.variantId || section.dataset.defaultVariantId;

    if (!variantId) {
      console.warn('No variant ID found for AJAX add to cart');
      return;
    }

    const defaultLabel = section.querySelector(SELECTORS.ctaText)?.textContent?.trim() || button.dataset.defaultLabel || 'Add to Cart';
    const originalHtml = button.innerHTML;

    try {
      button.disabled = true;
      button.classList.add('is-loading');

      const ctaText = section.querySelector(SELECTORS.ctaText);
      if (ctaText) ctaText.textContent = 'Adding...';

      await addToCart(variantId, 1);

      if (ctaText) ctaText.textContent = 'Added';
      button.classList.add('is-added');

      await refreshCartSections();

      setTimeout(() => {
        const activeOffer = getActiveOffer(section);
        if (activeOffer) {
          updateCtaFromOffer(section, activeOffer);
        } else if (ctaText) {
          ctaText.textContent = defaultLabel;
        } else {
          button.innerHTML = originalHtml;
        }

        button.classList.remove('is-added');
      }, 1500);
    } catch (error) {
      console.error(error);

      const ctaText = section.querySelector(SELECTORS.ctaText);
      if (ctaText) ctaText.textContent = 'Try Again';

      setTimeout(() => {
        const activeOffer = getActiveOffer(section);
        if (activeOffer) {
          updateCtaFromOffer(section, activeOffer);
        } else if (ctaText) {
          ctaText.textContent = defaultLabel;
        }
      }, 1500);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  function initHeroSection(section) {
    if (section.dataset.jsInitialized === 'true') return;
    section.dataset.jsInitialized = 'true';

    const offerCards = section.querySelectorAll(SELECTORS.offerCard);
    const addToCartBtn = section.querySelector(SELECTORS.addToCartBtn);

    offerCards.forEach((card) => {
      card.addEventListener('click', () => {
        setActiveOffer(section, card);
      });
    });

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => {
        handleAddToCart(section, addToCartBtn);
      });
    }

    const activeOffer = getActiveOffer(section);
    if (activeOffer) {
      setActiveOffer(section, activeOffer);
    }



function setMainImage(opts) {
          if (!mainImage || !opts) return;

          if (opts.src) {
            mainImage.src = opts.src;
          }

          if (opts.srcset) {
            mainImage.setAttribute('srcset', opts.srcset);
          } else {
            mainImage.removeAttribute('srcset');
          }

          if (opts.sizes) {
            mainImage.setAttribute('sizes', opts.sizes);
          } else {
            mainImage.removeAttribute('sizes');
          }

          if (opts.mediaId) {
            mainImage.setAttribute('data-media-id', opts.mediaId);
          }

          if (opts.alt) {
            mainImage.setAttribute('alt', opts.alt);
          }

          thumbs.forEach(function(thumb) {
            thumb.classList.toggle('active', String(thumb.dataset.mediaId) === String(opts.mediaId));
          });
        }

        function getActiveThumbIndex() {
          var activeIndex = 0;
          thumbs.forEach(function(thumb, index) {
            if (thumb.classList.contains('active')) activeIndex = index;
          });
          return activeIndex;
        }

        function activateThumbByIndex(index) {
          if (!thumbs.length) return;

          if (index < 0) index = thumbs.length - 1;
          if (index >= thumbs.length) index = 0;

          var thumb = thumbs[index];
          if (!thumb) return;

          setMainImage({
            src: thumb.dataset.full,
            srcset: thumb.dataset.srcset,
            sizes: thumb.dataset.sizes,
            mediaId: thumb.dataset.mediaId,
            alt: thumb.getAttribute('alt')
          });
        }


  }


  function getActiveBuyOption(section) {
  return section.querySelector(`${SELECTORS.buyOptionCard}.buy-option-active`) || section.querySelector(SELECTORS.buyOptionCard);
}

function setActiveBuyOption(section, optionCard) {
  const cards = section.querySelectorAll(SELECTORS.buyOptionCard);

  cards.forEach((card) => {
    const input = card.querySelector('input[type="radio"]');
    const isActive = card === optionCard;

    card.classList.toggle('buy-option-active', isActive);

    if (input) {
      input.checked = isActive;
    }
  });

  updateCtaFromBuyOption(section, optionCard);
}

function updateCtaFromBuyOption(section, optionCard) {
  if (!optionCard) return;

  const ctaPrice = section.querySelector(SELECTORS.ctaPrice);
  const ctaText = section.querySelector(SELECTORS.ctaText);
  const addToCartBtn = section.querySelector(SELECTORS.addToCartBtn);
  const state = getSectionState(section);

  const price = optionCard.dataset.price;
  const buttonLabel = optionCard.dataset.buttonLabel || addToCartBtn?.dataset.defaultLabel || 'Add to Cart';

  if (ctaText) {
    ctaText.textContent = buttonLabel;
  }

  if (ctaPrice) {
    ctaPrice.textContent = formatMoney(price, state.moneyFormat);
  }

  if (addToCartBtn) {
    addToCartBtn.dataset.variantId = optionCard.dataset.variantId;
  }
}

function initBuyBlockSection(section) {
  if (section.dataset.jsInitialized === 'true') return;
  section.dataset.jsInitialized = 'true';

  const optionCards = section.querySelectorAll(SELECTORS.buyOptionCard);
  const addToCartBtn = section.querySelector(SELECTORS.addToCartBtn);

  optionCards.forEach((card) => {
    card.addEventListener('click', () => {
      setActiveBuyOption(section, card);
    });

    const input = card.querySelector('input[type="radio"]');
    if (input) {
      input.addEventListener('change', () => {
        setActiveBuyOption(section, card);
      });
    }
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {
      handleAddToCart(section, addToCartBtn);
    });
  }

  const activeOption = getActiveBuyOption(section);
  if (activeOption) {
    setActiveBuyOption(section, activeOption);
  }
}


function getActiveFinalOption(section) {
  return section.querySelector(`${SELECTORS.finalOptionCard}.is-active`) || section.querySelector(SELECTORS.finalOptionCard);
}

function setActiveFinalOption(section, optionCard) {
  const cards = section.querySelectorAll(SELECTORS.finalOptionCard);

  cards.forEach((card) => {
    card.classList.toggle('is-active', card === optionCard);
  });
}

function initFinalCtaSection(section) {
  if (section.dataset.jsInitialized === 'true') return;
  section.dataset.jsInitialized = 'true';

  const optionCards = section.querySelectorAll(SELECTORS.finalOptionCard);
  const addToCartButtons = section.querySelectorAll(SELECTORS.addToCartBtn);

  optionCards.forEach((card) => {
    card.addEventListener('click', (event) => {
      const clickedButton = event.target.closest(SELECTORS.addToCartBtn);
      setActiveFinalOption(section, card);

      if (clickedButton) {
        handleAddToCart(section, clickedButton);
      }
    });
  });

  addToCartButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const card = button.closest(SELECTORS.finalOptionCard);
      if (card) {
        setActiveFinalOption(section, card);
      }

      handleAddToCart(section, button);
    });
  });

  const activeOption = getActiveFinalOption(section);
  if (activeOption) {
    setActiveFinalOption(section, activeOption);
  }
}

function initHeroGallery(section) {
  const thumbs = section.querySelectorAll(SELECTORS.galleryThumb);
  const mainImage = section.querySelector(SELECTORS.heroMainImage);

  if (!thumbs.length || !mainImage) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.mediaSrc;
      const srcset = thumb.dataset.mediaSrcset;
      const alt = thumb.dataset.mediaAlt || mainImage.getAttribute('alt') || '';

      if (src) {
        mainImage.setAttribute('src', src);
      }

      if (srcset) {
        mainImage.setAttribute('srcset', srcset);
      }

      mainImage.setAttribute('alt', alt);

      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
}


function initAllSections(root = document) {
  const sections = root.querySelectorAll(SELECTORS.section);

  sections.forEach((section) => {
    const type = section.dataset.gemProductSection;

    if (type === 'hero') {
      initHeroSection(section);
      initHeroGallery(section);
    }

    if (type === 'buy-block') {
      initBuyBlockSection(section);
    }

    if (type === 'final-cta') {
      initFinalCtaSection(section);
    }
  });
}

  document.addEventListener('DOMContentLoaded', () => {
    initAllSections(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAllSections(event.target);
  });
})();